import { Grid } from "antd";

const { useBreakpoint } = Grid;
const useIsDesktop = () => {
  //   const theme = useTheme();
  //   const isDesktop = useMediaQuery({ minWidth: theme.breakpoints.values.lg });
  //   return isDesktop;
  const screens = useBreakpoint();
  const isDesktop = screens.lg;

  return isDesktop;
};

export default useIsDesktop;
